import { useEffect } from 'react';

export const useChangeDocumentTitle = (pageTitle) => {
	useEffect(() => {
		document.title = `Noa Kosar | Personal Portfolio - ${pageTitle}`;
	}, [pageTitle]);
};
